module.exports = __webpack_public_path__ + "img/account.d59f0e04.jpg";